module.exports = __webpack_public_path__ + "img/step-active.35e72c8b.png";